import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://tskadwbejhenvtvfuayu.supabase.co";
const supabaseKey = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRza2Fkd2JlamhlbnZ0dmZ1YXl1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzcxNjc5OTQsImV4cCI6MTk5Mjc0Mzk5NH0.lP38jjhHs6REbbs6jTjtjFt6O9u4B7VbLSxuFLOKrPs`;
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
